import React from "react";
import { StyleSheet, Text, View } from "react-native";

import UserAvatar from "@/Components/Media/User/Images/UserAvatar";
import { type UserProfile } from "@/schemas/user/profile";
import WebCard from "@/Components/Cards/WebCard";
import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  profile: UserProfile;
};

function UserProfileCard({ profile }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    username: {
      fontSize: currentTheme.typography.h2.size.web,
      color: currentTheme.typography.h2.color,
      marginTop: 5,
    },
    statsContainer: {
      flexDirection: "row",
      paddingTop: 5,
    },
    statBox: {
      alignItems: "center",
      marginHorizontal: 12,
    },
    text: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
  });

  return (
    <WebCard>
      <View style={styles.container}>
        <UserAvatar
          avatar={profile.avatar}
          defaultAvatarColor={"white"}
          size={150}
        />
        <Text style={styles.username}>@{profile.username}</Text>
        <View style={styles.statsContainer}>
          <View style={styles.statBox}>
            <Text style={styles.text}>
              {profile.followerCount.toLocaleString()}
            </Text>
            <Text style={styles.text}>Followers</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.text}>
              {profile.followingCount.toLocaleString()}
            </Text>
            <Text style={styles.text}>Following</Text>
          </View>
        </View>
      </View>
    </WebCard>
  );
}

export default UserProfileCard;
